import {
    GET_PROVIDER_LOADING,
    GET_PROVIDER_SUCCESS,
    GET_PROVIDER_REJECT,
} from "../../actions/provider/getAll";

import {
    GET_CODE_ODOO_LOADING,
    GET_CODE_ODOO_SUCCESS,
    GET_CODE_ODOO_REJECT,
} from "../../actions/provider/getAllOdoo";

import {
    GET_PROVIDER_ID_LOADING,
    GET_PROVIDER_ID_SUCCESS,
    GET_PROVIDER_ID_REJECT,
} from "../../actions/provider/getId";

import {
    POST_PROVIDER_LOADING,
    POST_PROVIDER_SUCCESS,
    POST_PROVIDER_REJECT,
    POST_PROVIDER_RESET,
} from "../../actions/provider/post";

import {
    PUT_PROVIDER_LOADING,
    PUT_PROVIDER_SUCCESS,
    PUT_PROVIDER_REJECT,
    PUT_PROVIDER_RESET,
} from "../../actions/provider/put";

import {
    DELETE_PROVIDER_LOADING,
    DELETE_PROVIDER_SUCCESS,
    DELETE_PROVIDER_REJECT,
    DELETE_PROVIDER_RESET,
} from "../../actions/provider/delete";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    put: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    delete: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    codesOdoo: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
}

const providerReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_PROVIDER_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_PROVIDER_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_PROVIDER_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        // ------------- GET ID ID --------------------
        case GET_PROVIDER_ID_LOADING: return {
            ...state,
            detail: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_PROVIDER_ID_SUCCESS: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_PROVIDER_ID_REJECT: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

        // ------------- POST --------------------
        case POST_PROVIDER_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_PROVIDER_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_PROVIDER_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_PROVIDER_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT --------------------
        case PUT_PROVIDER_LOADING: return {
            ...state,
            put: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_PROVIDER_SUCCESS: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_PROVIDER_REJECT: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_PROVIDER_RESET: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- DELETE --------------------
        case DELETE_PROVIDER_LOADING: return {
            ...state,
            delete: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_PROVIDER_SUCCESS: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_PROVIDER_REJECT: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_PROVIDER_RESET: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

         // ------------- GET ALL CODES ODOO --------------------
         case GET_CODE_ODOO_LOADING: return {
            ...state,
            codesOdoo: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_CODE_ODOO_SUCCESS: return {
            ...state,
            codesOdoo: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_CODE_ODOO_REJECT: return {
            ...state,
            codesOdoo: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

        default: return state;
    }
}

export default providerReducer